import { Tabs, Tab } from 'carbon-react/esm/components/tabs';
import Box from 'carbon-react/esm/components/box';
import CollaboratorTab from './collaboratorTab';
import ProfilesTab from './profilesTab/index';
import { AdminTabEnum } from './admin.constants';
import { ProfilesProvider } from '../../../context/ProfilesContext';
import { useResponsive } from '../../../hooks/useResponsive';
import { Typography } from 'carbon-react/esm/components/typography/__internal__/__next__/typography.component';
import styled from 'styled-components';

const FullWidthTabsContainer = styled.div`
  box-sizing: border-box;
  min-width: 0;
  width: 100%;

  > [data-component='tabs'] {
    box-sizing: border-box;
    min-width: 0;
    width: 100%;
  }

  > [data-component='tabs'] > :not([data-role='tab-list-wrapper']) {
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }

  [data-component='tab-panel'] {
    box-sizing: border-box;
    min-width: 0;
    width: 100%;
  }

  &[data-orientation='vertical'] [data-component='tab-list'] {
    margin-right: 0;
  }

  &[data-orientation='vertical'] [data-component='tab-panel'] {
    padding: 0;
  }
`;

const AdminLayout = ({ selectedTab }: { selectedTab?: AdminTabEnum }) => {
  const tabId = selectedTab ?? `${AdminTabEnum.Collaborators}`;
  const { isDesktopOrLarger, isMobile } = useResponsive();

  return (
    <ProfilesProvider>
      <Box pt={24} pb={24} pl={16} pr={16} border-radius="var(--borderRadius000)">
        <Typography variant="h1">Administration</Typography>
      </Box>

      <Box bg="#f2f5f6" display="flex" width="100%">
        <FullWidthTabsContainer data-orientation={isDesktopOrLarger ? 'vertical' : 'horizontal'}>
          <Tabs
            position={isDesktopOrLarger ? 'left' : 'top'}
            size={isMobile ? 'default' : 'large'}
            selectedTabId={tabId}
          >
            <Tab label="Mes collaborateurs" id={`${AdminTabEnum.Collaborators}`} key="tab-1">
              <CollaboratorTab />
            </Tab>
            <Tab label="Mes profils" id={`${AdminTabEnum.Profiles}`} key="tab-2">
              <ProfilesTab />
            </Tab>
          </Tabs>
        </FullWidthTabsContainer>
      </Box>
    </ProfilesProvider>
  );
};

export default AdminLayout;
